// extracted by mini-css-extract-plugin
export default {"preference":"Preference_preference__9K8NW","preference_wrap":"Preference_preference_wrap__gubKT","btnAnim":"Preference_btnAnim__9ux+T","btnAnim2":"Preference_btnAnim2__vznrb"};